// Member information is maintained here. Long biographies remain in about.md.
import piAvatar from "../Assets/Members/prof_zhao/portrait.jpg";
import junzhaoAvatar from "../Assets/Members/zhaojun/portrait.jpg";
import junzhaoBiography from "../Assets/Members/zhaojun/about.md";
import ningliAvatar from "../Assets/Members/lining/portrait.jpg";
import ningliBiography from "../Assets/Members/lining/about.md";
import kangshuliAvatar from "../Assets/Members/likangshu/portrait.jpg";
import kangshuliBiography from "../Assets/Members/likangshu/about.md";
import wenchaohuAvatar from "../Assets/Members/huwenchao/portrait.jpg";
import wenchaohuBiography from "../Assets/Members/huwenchao/about.md";
import wingnichengAvatar from "../Assets/Members/wingnicheng/portrait.jpg";
import wingnichengBiography from "../Assets/Members/wingnicheng/about.md";
import yuanmengAvatar from "../Assets/Members/mengyuan/portrait.jpg";
import yuanmengBiography from "../Assets/Members/mengyuan/about.md";
import ziyihanAvatar from "../Assets/Members/hanziyi/portrait.jpg";
import ziyihanBiography from "../Assets/Members/hanziyi/about.md";
import shangtienyangAvatar from "../Assets/Members/yangshangtian/portrait.jpg";
import shangtienyangBiography from "../Assets/Members/yangshangtian/about.md";
import yuliangAvatar from "../Assets/Members/liangyu/portrait.jpg";
import yuliangBiography from "../Assets/Members/liangyu/about.md";
import qianwenpengAvatar from "../Assets/Members/pengqianwen/portrait.jpg";
import qianwenpengBiography from "../Assets/Members/pengqianwen/about.md";
import zijianwangAvatar from "../Assets/Members/wangzijian/portrait.jpg";
import zijianwangBiography from "../Assets/Members/wangzijian/about.md";
import junchenngAvatar from "../Assets/Members/ngjunchen/portrait.jpg";
import junchenngBiography from "../Assets/Members/ngjunchen/about.md";
import yangcaoAvatar from "../Assets/Members/caoyang/portrait.jpg";
import yangcaoBiography from "../Assets/Members/caoyang/about.md";
import jianningzengAvatar from "../Assets/Members/zengjianning/portrait.jpg";
import jianningzengBiography from "../Assets/Members/zengjianning/about.md";
import jialuowangAvatar from "../Assets/Members/wangjialuo/portrait.jpg";
import jialuowangBiography from "../Assets/Members/wangjialuo/about.md";
import mingweiwangAvatar from "../Assets/Members/wangmingwei/portrait.jpg";
import mingweiwangBiography from "../Assets/Members/wangmingwei/about.md";
import huilingyuAvatar from "../Assets/Members/yuhuiling/portrait.jpg";
import huilingyuBiography from "../Assets/Members/yuhuiling/about.md";
import yujiachenAvatar from "../Assets/Members/chenyujia/portrait.jpeg";
import yujiachenBiography from "../Assets/Members/chenyujia/about.md";
import junxianliAvatar from "../Assets/Members/lijunxian/portrait.jpg";
import junxianliBiography from "../Assets/Members/lijunxian/about.md";
import yesunAvatar from "../Assets/Members/sunye/portrait.jpg";
import yesunBiography from "../Assets/Members/sunye/about.md";
import kaiyueweAvatar from "../Assets/Members/ewekaiyu/portrait.jpg";
import kaiyueweBiography from "../Assets/Members/ewekaiyu/about.md";
import honglonglaiAvatar from "../Assets/Members/laihonglong/portrait.jpg";
import honglonglaiBiography from "../Assets/Members/laihonglong/about.md";
import poweichengAvatar from "../Assets/Members/chengpowei/portrait.jpg";
import poweichengBiography from "../Assets/Members/chengpowei/about.md";
import weianchenAvatar from "../Assets/Members/chenweian/portrait.jpg";
import weianchenBiography from "../Assets/Members/chenweian/about.md";
import wonghsinhuiAvatar from "../Assets/Members/wonghsinhui/portrait.jpg";
import wonghsinhuiBiography from "../Assets/Members/wonghsinhui/about.md";
import huijunliuAvatar from "../Assets/Members/huijunliu/portrait.jpg";
import huijunliuBiography from "../Assets/Members/huijunliu/about.md";
import yanliAvatar from "../Assets/Members/liyan/portrait.jpg";
import yanliBiography from "../Assets/Members/liyan/about.md";
import xiaoruoliAvatar from "../Assets/Members/lixiaoruo/portrait.jpg";
import xiaoruoliBiography from "../Assets/Members/lixiaoruo/about.md";
import shengqiangwuAvatar from "../Assets/Members/wushengqiang/portrait.jpg";
import shengqiangwuBiography from "../Assets/Members/wushengqiang/about.md";
import xiaocanghanAvatar from "../Assets/Members/hanxiaocang/portrait.jpg";
import xiaocanghanBiography from "../Assets/Members/hanxiaocang/about.md";
import zanlinqiuAvatar from "../Assets/Members/qiuzanlin/portrait.jpg";
import zanlinqiuBiography from "../Assets/Members/qiuzanlin/about.md";
import songhuangBiography from "../Assets/Members/huangsong/about.md";
import xiangchenBiography from "../Assets/Members/chenxiang/about.md";
import xuanzhouBiography from "../Assets/Members/zhouxuan/about.md";
import qingduowangAvatar from "../Assets/Members/qingduowang/portrait.jpg";
import qingduowangBiography from "../Assets/Members/qingduowang/about.md";
import nanfengqiuBiography from "../Assets/Members/qiunanfeng/about.md";
import yichuanliBiography from "../Assets/Members/liyichuan/about.md";
import kenlinBiography from "../Assets/Members/linken/about.md";
import xiaoliheAvatar from "../Assets/Members/hexiaoli/portrait.jpg";
import xiaoliheBiography from "../Assets/Members/hexiaoli/about.md";

export const memberGroups = [
    {
        "id": "pi",
        "label": "Principal Investigator"
    },
    {
        "id": "postdoctoral",
        "label": "Postdoctoral"
    },
    {
        "id": "phd",
        "label": "Ph.D. Candidate"
    },
    {
        "id": "masters",
        "label": "M.S. Candidate"
    },
    {
        "id": "visiting",
        "label": "Visiting Student"
    },
    {
        "id": "undergraduate",
        "label": "Undergraduate Intern"
    },
    {
        "id": "alumni",
        "label": "Alumni"
    }
];

const members = [
    {
        "id": "xiaoxuzhao",
        "name": "Xiaoxu Zhao (赵晓续)",
        "group": "pi",
        "role": "Principal Investigator and Ph.D. Supervisor",
        "path": "/",
        "showOnTeam": true,
        "email": "xiaoxuzhao@pku.edu.cn",
        "education": [],
        "photoMode": "original",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": piAvatar,
        "biography": null
    },
    {
        "id": "junzhao",
        "name": "Dr. Jun Zhao (赵君)",
        "group": "postdoctoral",
        "role": "Postdoctoral Associate",
        "path": "/member/junzhao",
        "showOnTeam": true,
        "email": "jun_zhao@pku.edu.cn",
        "education": [
            {
                "institution": "Peking University",
                "degree": "Postdoctoral Fellow",
                "period": "2023-Present",
                "showOnCard": false
            },
            {
                "institution": "Tianjin University",
                "degree": "Ph.D.",
                "period": "2019-2023",
                "showOnCard": true
            },
            {
                "institution": "Tianjin University",
                "degree": "Master's Degree",
                "period": "2016-2019",
                "showOnCard": true
            },
            {
                "institution": "Hebei Normal University of Science and Technology",
                "degree": "Bachelor's Degree",
                "period": "2012-2016",
                "showOnCard": true
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": junzhaoAvatar,
        "biography": junzhaoBiography
    },
    {
        "id": "ningli",
        "name": "Dr. Ning Li (李宁)",
        "group": "postdoctoral",
        "role": "Postdoctoral Associate",
        "path": "/member/ningli",
        "showOnTeam": true,
        "email": "18810575072@163.com",
        "education": [
            {
                "institution": "University Sciences and Technology Beijing",
                "degree": "Ph.D.",
                "period": "2017.09-2023.01",
                "showOnCard": true
            },
            {
                "institution": "National University of Singapore",
                "degree": "Visiting Student",
                "period": "2019.12-2021.12",
                "showOnCard": true
            },
            {
                "institution": "Chang'an University",
                "degree": "B.S.",
                "period": "2011.09-2015.07",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "Postdoctoral Fellow",
                "period": "2023.10-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": ningliAvatar,
        "biography": ningliBiography
    },
    {
        "id": "kangshuli",
        "name": "Kangshu Li (李康舒)",
        "group": "phd",
        "role": "Ph.D. Candidate",
        "path": "/member/kangshuli",
        "showOnTeam": true,
        "email": "2301112389@stu.pku.edu.cn",
        "education": [
            {
                "institution": "Shandong University",
                "degree": "Bachelor's Degree",
                "period": "2019-2023",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "Ph.D.",
                "period": "2023-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": kangshuliAvatar,
        "biography": kangshuliBiography
    },
    {
        "id": "wenchaohu",
        "name": "Wenchao Hu (胡文超)",
        "group": "phd",
        "role": "Co-supervized with Prof Ruqiang Zou,\nPh.D. Candidate",
        "path": "/member/wenchaohu",
        "showOnTeam": true,
        "email": "2201111883@stu.pku.edu.cn",
        "education": [
            {
                "institution": "Wuhan University",
                "degree": "B.S.",
                "period": "2018-2022",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "Ph.D.",
                "period": "2022-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": wenchaohuAvatar,
        "biography": wenchaohuBiography
    },
    {
        "id": "wingnicheng",
        "name": "Wingni Cheng (郑咏妮)",
        "group": "phd",
        "role": "Ph.D. Candidate",
        "path": "/member/wingnicheng",
        "showOnTeam": true,
        "email": "2201213675@stu.pku.edu.cn",
        "education": [
            {
                "institution": "Nanjing University",
                "degree": "Bachelor’s Degree",
                "period": "2018-2022",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "Ph.D.",
                "period": "2022-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": wingnichengAvatar,
        "biography": wingnichengBiography
    },
    {
        "id": "yuanmeng",
        "name": "Yuan Meng (孟媛)",
        "group": "phd",
        "role": "Ph.D. Candidate",
        "path": "/member/yuanmeng",
        "showOnTeam": true,
        "email": "mengyuan0020@stu.pku.edu.cn",
        "education": [
            {
                "institution": "Beijing Normal University",
                "degree": "Bachelor's Degree",
                "period": "2020-2024",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "Ph.D.",
                "period": "2024- Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": yuanmengAvatar,
        "biography": yuanmengBiography
    },
    {
        "id": "ziyihan",
        "name": "Ziyi Han (韩紫怡)",
        "group": "phd",
        "role": "Ph.D. Candidate",
        "path": "/member/ziyihan",
        "showOnTeam": true,
        "email": "hanziyi_1999@pku.edu.cn",
        "education": [
            {
                "institution": "Hebei Normal University",
                "degree": "B.S.",
                "period": "2017-2021",
                "showOnCard": true
            },
            {
                "institution": "Tianjin University",
                "degree": "M.S.",
                "period": "2021-2025",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "Ph.D.",
                "period": "2022-present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": ziyihanAvatar,
        "biography": ziyihanBiography
    },
    {
        "id": "shangtienyang",
        "name": "Shangtien Yang (杨赏恬)",
        "group": "phd",
        "role": "Ph.D. Candidate",
        "path": "/member/shangtienyang",
        "showOnTeam": true,
        "email": "sweetw200502575@163.com",
        "education": [
            {
                "institution": "Peking University",
                "degree": "Ph.D.",
                "period": "2026-Present",
                "showOnCard": false
            },{
                "institution": "Peking University",
                "degree": "M.S.",
                "period": "2023.09-2026",
                "showOnCard": true
            },
            {
                "institution": "East China University of Science and Technology",
                "degree": "B.S.",
                "period": "2019.09-2023.06",
                "showOnCard": true
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": shangtienyangAvatar,
        "biography": shangtienyangBiography
    },
    {
        "id": "yuliang",
        "name": "Yu Liang (梁聿)",
        "group": "phd",
        "role": "Ph.D. Candidate",
        "path": "/member/yuliang",
        "showOnTeam": true,
        "email": "johnson508ro@163.com",
        "education": [
            {
                "institution": "Tsinghua University",
                "degree": "B.S.",
                "period": "2020-2024",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "M.S.",
                "period": "2024.09-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": yuliangAvatar,
        "biography": yuliangBiography
    },
    {
        "id": "qianwenpeng",
        "name": "Qianwen Peng (彭倩雯)",
        "group": "phd",
        "role": "Ph.D. Candidate",
        "path": "/member/qianwenpeng",
        "showOnTeam": true,
        "email": "18073455571@163.com",
        "education": [
            {
                "institution": "Beijing Normal University",
                "degree": "Bachelor's Degree",
                "period": "2021-2025",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "Ph.D.",
                "period": "2025-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": qianwenpengAvatar,
        "biography": qianwenpengBiography
    },
    {
        "id": "zijianwang",
        "name": "Zijian Wang (王梓健)",
        "group": "phd",
        "role": "Co-supervized with Prof Jin Zhang,\nPh.D. Candidate",
        "path": "/member/zijianwang",
        "showOnTeam": true,
        "email": "15804505102@163.com",
        "education": [
            {
                "institution": "Zhengzhou university",
                "degree": "Bachelor's Degree",
                "period": "2021-2025",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "Ph.D.",
                "period": "2025-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": zijianwangAvatar,
        "biography": zijianwangBiography
    },
    {
        "id": "junchenng",
        "name": "Jun Chen Ng (黄俊晨)",
        "group": "phd",
        "role": "Ph.D. Candidate",
        "path": "/member/junchenng",
        "showOnTeam": true,
        "email": "junchen1216@gmail.com",
        "education": [
            {
                "institution": "University of Malaya",
                "degree": "B.S.",
                "period": "2020-2024",
                "showOnCard": true
            },
            {
                "institution": "University of Malaya",
                "degree": "M.S.",
                "period": "2024-2025",
                "showOnCard": true
            },
            {
                "institution": "Peking University, China",
                "degree": "Ph.D.",
                "period": "2025-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": junchenngAvatar,
        "biography": junchenngBiography
    },
    {
        "id": "yangcao",
        "name": "Yang Cao (曹阳)",
        "group": "phd",
        "role": "Ph.D. Candidate",
        "path": "/member/yangcao",
        "showOnTeam": true,
        "email": "yangcao25@stu.pku.edu.cn",
        "education": [
            {
                "institution": "Shandong University",
                "degree": "B.S.",
                "period": "2021.09–2025.07",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "Ph.D.",
                "period": "2025.09-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": yangcaoAvatar,
        "biography": yangcaoBiography
    },
    {
        "id": "jianningzeng",
        "name": "JIanning Zeng (曾建宁)",
        "group": "phd",
        "role": "Ph.D. Candidate",
        "path": "/member/jianningzeng",
        "showOnTeam": true,
        "email": "1031687476@qq.com",
        "education": [
            {
                "institution": "Jinan University",
                "degree": "Bachelor's Degree",
                "period": "2019-2023",
                "showOnCard": true
            },
            {
                "institution": "Guangdong University of Technology",
                "degree": "Master's Degree",
                "period": "2023-2025",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "Master's Degree",
                "period": "2025-2026",
                "showOnCard": false
            },
            {
                "institution": "Peking University",
                "degree": "Ph.D.",
                "period": "2026-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": jianningzengAvatar,
        "biography": jianningzengBiography
    },
    {
        "id": "jialuowang",
        "name": "Jialuo Wang (王佳珞)",
        "group": "phd",
        "role": "Ph.D. Candidate",
        "path": "/member/jialuowang",
        "showOnTeam": true,
        "email": "wangjialuo330@163.com",
        "education": [
            {
                "institution": "Beijing University of Technology",
                "degree": "Bachelor's Degree",
                "period": "2022-2026",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "Ph.D.",
                "period": "2026-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": jialuowangAvatar,
        "biography": jialuowangBiography
    },
    {
        "id": "mingweiwang",
        "name": "Mingwei Wang (王明伟)",
        "group": "phd",
        "role": "Ph.D. Candidate",
        "path": "/member/mingweiwang",
        "showOnTeam": true,
        "email": "2601112576@stu.pku.edu.cn",
        "education": [
            {
                "institution": "Tongji University",
                "degree": "Bachelor's Degree",
                "period": "2022-2026",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "Ph.D.",
                "period": "2026-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": mingweiwangAvatar,
        "biography": mingweiwangBiography
    },
    {
        "id": "huilingyu",
        "name": "Hui Ling Yu (余慧凌)",
        "group": "phd",
        "role": "Ph.D. Candidate",
        "path": "/member/huilingyu",
        "showOnTeam": true,
        "email": "huiling26@stu.pku.edu.cn",
        "education": [
            {
                "institution": "Lancaster University & Sunway University",
                "degree": "B.S.",
                "period": "2019–2023",
                "showOnCard": true
            },
            {
                "institution": "University of Malaya",
                "degree": "M.S.",
                "period": "2023–2025",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "Ph.D.",
                "period": "2026–Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": huilingyuAvatar,
        "biography": huilingyuBiography
    },
    {
        "id": "yujiachen",
        "name": "Yujia Chen (陈雨佳)",
        "group": "phd",
        "role": "Ph.D. Candidate",
        "path": "/member/yujiachen",
        "showOnTeam": true,
        "email": "1341291261@qq.com",
        "education": [
            {
                "institution": "Shanghai Jiao Tong University",
                "degree": "B.S.",
                "period": "2021–2027",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "Ph.D.",
                "period": "2027–Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": yujiachenAvatar,
        "biography": yujiachenBiography
    },
    {
        "id": "junxianli",
        "name": "Junxian Li (李俊贤)",
        "group": "masters",
        "role": "M.S. Candidate",
        "path": "/member/junxianli",
        "showOnTeam": true,
        "email": "potassium39@163.com",
        "education": [
            {
                "institution": "Beijing Normal University",
                "degree": "Bachelor's Degree",
                "period": "2020-2024",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "Master's Degree",
                "period": "2024-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": junxianliAvatar,
        "biography": junxianliBiography
    },
    {
        "id": "yesun",
        "name": "Ye Sun (孙烨)",
        "group": "masters",
        "role": "M.S. Candidate",
        "path": "/member/yesun",
        "showOnTeam": true,
        "email": "sunye1128@163.com",
        "education": [
            {
                "institution": "Peking University",
                "degree": "Bachelor's Degree",
                "period": "2020-2024",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "",
                "period": "2024-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": yesunAvatar,
        "biography": yesunBiography
    },
    {
        "id": "kaiyuewe",
        "name": "Kai Yu Ewe (尤恺宇)",
        "group": "masters",
        "role": "M.S. Candidate",
        "path": "/member/kaiyuewe",
        "showOnTeam": true,
        "email": "ewekaiyukye@gmail.com",
        "education": [
            {
                "institution": "Tsinghua University",
                "degree": "B.S.",
                "period": "2021.09-2025.07",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "M.S.",
                "period": "2025.09-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": kaiyueweAvatar,
        "biography": kaiyueweBiography
    },
    {
        "id": "honglonglai",
        "name": "Honglong Lai (赖弘龙)",
        "group": "masters",
        "role": "M.S. Candidate",
        "path": "/member/honglonglai",
        "showOnTeam": true,
        "email": "2501212788@stu.pku.edu.cn",
        "education": [
            {
                "institution": "Xi'an Jiaotong University",
                "degree": "Bachelor's Degree",
                "period": "2021-2025",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "Master's Degree",
                "period": "2025-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": honglonglaiAvatar,
        "biography": honglonglaiBiography
    },
    {
        "id": "poweicheng",
        "name": "PoWei Cheng (鄭伯維)",
        "group": "masters",
        "role": "M.S. Candidate",
        "path": "/member/poweicheng",
        "showOnTeam": true,
        "email": "2091124561@qq.com",
        "education": [
            {
                "institution": "Wuhan University of Technology",
                "degree": "Bachelor's Degree",
                "period": "2022-2026",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "Master's Degree",
                "period": "2026-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": poweichengAvatar,
        "biography": poweichengBiography
    },
    {
        "id": "weianchen",
        "name": "WeiAn Chen (陳薇安)",
        "group": "masters",
        "role": "M.S. Candidate",
        "path": "/member/weianchen",
        "showOnTeam": true,
        "email": "weianchen831@gmail.com",
        "education": [
            {
                "institution": "National Tsing Hua University",
                "degree": "B.S.",
                "period": "2022.09-2026.06",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "M.S.",
                "period": "2026-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": weianchenAvatar,
        "biography": weianchenBiography
    },
    {
        "id": "wonghsinhui",
        "name": "Hsin Hui Wong (王歆惠)",
        "group": "visiting",
        "role": "Visiting PhD. Candidate",
        "path": "/member/wonghsinhui",
        "showOnTeam": true,
        "email": "wonghsinhui@gmail.com",
        "education": [
            {
                "institution": "University of Malaya",
                "degree": "B.S.",
                "period": "2020-2024",
                "showOnCard": true
            },
            {
                "institution": "University of Malaya",
                "degree": "Ph.D.",
                "period": "2024-Present",
                "showOnCard": false
            },
            {
                "institution": "Peking University",
                "degree": "Ph.D.",
                "period": "2025-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": wonghsinhuiAvatar,
        "biography": wonghsinhuiBiography
    },
    {
        "id": "huijunliu",
        "name": "Huijun Liu (刘慧军)",
        "group": "visiting",
        "role": "Visiting M.S. Candidate",
        "path": "/member/huijunliu",
        "showOnTeam": true,
        "email": "2509260694@qq.com",
        "education": [
            {
                "institution": "Taiyuan University of Technology",
                "degree": "Bachelor's Degree",
                "period": "2019-2023",
                "showOnCard": true
            },
            {
                "institution": "Taiyuan University of Technology",
                "degree": "Master's Degree",
                "period": "2023-Present",
                "showOnCard": false
            },
            {
                "institution": "Peking University",
                "degree": "Master's Degree",
                "period": "2024-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": huijunliuAvatar,
        "biography": huijunliuBiography
    },
    {
        "id": "yanli",
        "name": "Yan Li (李岩)",
        "group": "visiting",
        "role": "Visiting M.S. Candidate",
        "path": "/member/yanli",
        "showOnTeam": true,
        "email": "LY18222887725@163.com",
        "education": [
            {
                "institution": "Taiyuan University of Technology",
                "degree": "Bachelor's Degree",
                "period": "2020-2024",
                "showOnCard": true
            },
            {
                "institution": "Taiyuan University of Technology",
                "degree": "Master's Degree",
                "period": "2024-Present",
                "showOnCard": false
            },
            {
                "institution": "Peking University",
                "degree": "Master's Degree",
                "period": "2025-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": yanliAvatar,
        "biography": yanliBiography
    },
    {
        "id": "xiaoruoli",
        "name": "Xiaoruo Li (李晓若)",
        "group": "visiting",
        "role": "Visiting M.S. Candidate",
        "path": "/member/xiaoruoli",
        "showOnTeam": true,
        "email": "2936004817@qq.com",
        "education": [
            {
                "institution": "North University of China",
                "degree": "Bachelor's Degree",
                "period": "2021-2025",
                "showOnCard": true
            },
            {
                "institution": "North University of China",
                "degree": "Master's Degree",
                "period": "2025-Present",
                "showOnCard": false
            },
            {
                "institution": "Peking University",
                "degree": "Master's Degree",
                "period": "2026-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": xiaoruoliAvatar,
        "biography": xiaoruoliBiography
    },
    {
        "id": "shengqiangwu",
        "name": "Dr. Shengqiang Wu (吴胜强)",
        "group": "alumni",
        "role": "Research Associate Professor",
        "path": "/member/shengqiangwu",
        "showOnTeam": true,
        "email": "",
        "education": [
            {
                "institution": "Xian Jiaotong University",
                "degree": "Ph.D.",
                "period": "2016,09-2020,07",
                "showOnCard": true
            },
            {
                "institution": "Xian Jiaotong University",
                "degree": "Master's Degree",
                "period": "2013,09-2016,06",
                "showOnCard": true
            },
            {
                "institution": "Henan University of Technology",
                "degree": "Bachelor's Degree",
                "period": "2009,09-2013,06",
                "showOnCard": true
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": shengqiangwuAvatar,
        "biography": shengqiangwuBiography
    },
    {
        "id": "xiaocanghan",
        "name": "Dr. Xiaocang Han (韩小藏)",
        "group": "alumni",
        "role": "Postdoctoral Associate",
        "path": "/member/xiaocanghan",
        "showOnTeam": true,
        "email": "",
        "education": [
            {
                "institution": "Sichuan University",
                "degree": "Bachelor's Degree",
                "period": "2011-2015",
                "showOnCard": true
            },
            {
                "institution": "Shanghai Jiao Tong University",
                "degree": "Ph.D.",
                "period": "2015-2022",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "Postdoctoral Fellow",
                "period": "2022-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": xiaocanghanAvatar,
        "biography": xiaocanghanBiography
    },
    {
        "id": "zanlinqiu",
        "name": "Dr. Zanlin Qiu(邱赞霖)",
        "group": "alumni",
        "role": "Postdoctoral Associate",
        "path": "/member/zanlinqiu",
        "showOnTeam": true,
        "email": "",
        "education": [],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": zanlinqiuAvatar,
        "biography": zanlinqiuBiography
    },
    {
        "id": "songhuang",
        "name": "SONG HUANG (黄淞)",
        "group": "historical",
        "role": "",
        "path": "/member/songhuang",
        "showOnTeam": false,
        "email": "",
        "education": [
            {
                "institution": "graduated from Guangdong University of Technology",
                "degree": "bachelor",
                "period": "2015-2019",
                "showOnCard": true
            },
            {
                "institution": "graduated from Guangdong University of Technology",
                "degree": "Master",
                "period": "2019- 2022",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "",
                "period": "2023- Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": null,
        "biography": songhuangBiography
    },
    {
        "id": "xiangchen",
        "name": "XIANG CHEN (陈湘)",
        "group": "historical",
        "role": "",
        "path": "/member/xiangchen",
        "showOnTeam": false,
        "email": "",
        "education": [
            {
                "institution": "Peking University",
                "degree": "bachelor’s degree",
                "period": "2019-2023",
                "showOnCard": false
            },
            {
                "institution": "Peking University",
                "degree": "master’s degree",
                "period": "2023-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": null,
        "biography": xiangchenBiography
    },
    {
        "id": "xuanzhou",
        "name": "XUAN ZHOU (周萱)",
        "group": "historical",
        "role": "",
        "path": "/member/xuanzhou",
        "showOnTeam": false,
        "email": "2752808924@qq.com",
        "education": [
            {
                "institution": "Huaihua University",
                "degree": "bachelor's degree",
                "period": "2018-2022",
                "showOnCard": true
            },
            {
                "institution": "Guangdong University of Technology",
                "degree": "",
                "period": "2022-Present",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "",
                "period": "2023-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": null,
        "biography": xuanzhouBiography
    },
    {
        "id": "qingduowang",
        "name": "Qingduo Wang (王庆铎)",
        "group": "historical",
        "role": "",
        "path": "/member/QingduoWang",
        "showOnTeam": false,
        "email": "508001844@qq.com",
        "education": [
            {
                "institution": "Qingdao University of Science and Technology",
                "degree": "bachelor's degree",
                "period": "2019-2023",
                "showOnCard": true
            },
            {
                "institution": "Taiyuan University of Technology",
                "degree": "",
                "period": "2023-Present",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "",
                "period": "2024-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": qingduowangAvatar,
        "biography": qingduowangBiography
    },
    {
        "id": "nanfengqiu",
        "name": "Nanfeng Qiu(秋南风)",
        "group": "historical",
        "role": "",
        "path": "/member/NanfengQiu",
        "showOnTeam": false,
        "email": "",
        "education": [
            {
                "institution": "Peking University",
                "degree": "",
                "period": "2022-2026",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": null,
        "biography": nanfengqiuBiography
    },
    {
        "id": "yichuanli",
        "name": "Yichuan Li(李一川)",
        "group": "historical",
        "role": "",
        "path": "/member/YichuanLi",
        "showOnTeam": false,
        "email": "",
        "education": [],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": null,
        "biography": yichuanliBiography
    },
    {
        "id": "kenlin",
        "name": "Ken Lin(林肯)",
        "group": "historical",
        "role": "",
        "path": "/member/KenLin",
        "showOnTeam": false,
        "email": "",
        "education": [
            {
                "institution": "Peking University",
                "degree": "",
                "period": "2022.09-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": null,
        "biography": kenlinBiography
    },
    {
        "id": "xiaolihe",
        "name": "XIAOLI HE (何晓丽)",
        "group": "historical",
        "role": "",
        "path": "/member/XiaoliHe",
        "showOnTeam": false,
        "email": "1438647423@qq.com",
        "education": [
            {
                "institution": "Guangdong University of Technology",
                "degree": "",
                "period": "2024-Present",
                "showOnCard": true
            },
            {
                "institution": "Peking University",
                "degree": "",
                "period": "2025-Present",
                "showOnCard": false
            }
        ],
        "photoMode": "cover",
        "currentPosition": {
            "organization": "",
            "title": "",
            "since": ""
        },
        "avatar": xiaoliheAvatar,
        "biography": xiaoliheBiography
    },
];

export default members;
